/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Androidbeta_Steps_Signin2Inputs */

const id_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk dengan akun Google Anda`)
};

const ms_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk dengan akaun Google anda`)
};

const da_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind med din Google-konto`)
};

const de_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden Sie sich mit Ihrem Google-Konto an`)
};

const en_us2_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with your Google account`)
};

const es_es2_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión con tu cuenta de Google`)
};

const es_mx2_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión con tu cuenta de Google`)
};

const fil_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-sign in gamit ang iyong Google account`)
};

const fr_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous avec votre compte Google`)
};

const it_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi con il tuo account Google`)
};

const hu_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelentkezz be a Google fiókoddal`)
};

const nl_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in met je Google-account`)
};

const no_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg inn med Google-kontoen din`)
};

const pl_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się przez konto Google`)
};

const pt_br2_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça login com sua conta Google`)
};

const pt_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicie sessão com a sua conta Google`)
};

const ro_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autentifică-te cu contul tău Google`)
};

const fi_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään Google-tililläsi`)
};

const sv_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in med ditt Google-konto`)
};

const vi_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập bằng tài khoản Google của bạn`)
};

const tr_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google hesabınızla oturum açın`)
};

const cs_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlaste se svým Google účtem`)
};

const bg_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Влезте с вашия Google акаунт`)
};

const ru_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите через свою учётную запись Google`)
};

const uk_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійдіть за допомогою облікового запису Google`)
};

const ar_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل الدخول بحساب Google الخاص بك`)
};

const hi_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google खाते से साइन इन करें`)
};

const th_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลงชื่อเข้าใช้ด้วยบัญชี Google ของคุณ`)
};

const ja_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google アカウントでサインイン`)
};

const zh_cn2_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用您的Google账户登录`)
};

const zh_hant1_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用您的Google帳戶登入`)
};

const ko_misc_androidbeta_steps_signin2 = /** @type {(inputs: Misc_Androidbeta_Steps_Signin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google 계정으로 로그인`)
};

/**
* | output |
* | --- |
* | "Sign in with your Google account" |
*
* @param {Misc_Androidbeta_Steps_Signin2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_androidbeta_steps_signin2 = /** @type {((inputs?: Misc_Androidbeta_Steps_Signin2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Androidbeta_Steps_Signin2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_androidbeta_steps_signin2(inputs)
	if (locale === "ms") return ms_misc_androidbeta_steps_signin2(inputs)
	if (locale === "da") return da_misc_androidbeta_steps_signin2(inputs)
	if (locale === "de") return de_misc_androidbeta_steps_signin2(inputs)
	if (locale === "en-US") return en_us2_misc_androidbeta_steps_signin2(inputs)
	if (locale === "es-ES") return es_es2_misc_androidbeta_steps_signin2(inputs)
	if (locale === "es-MX") return es_mx2_misc_androidbeta_steps_signin2(inputs)
	if (locale === "fil") return fil_misc_androidbeta_steps_signin2(inputs)
	if (locale === "fr") return fr_misc_androidbeta_steps_signin2(inputs)
	if (locale === "it") return it_misc_androidbeta_steps_signin2(inputs)
	if (locale === "hu") return hu_misc_androidbeta_steps_signin2(inputs)
	if (locale === "nl") return nl_misc_androidbeta_steps_signin2(inputs)
	if (locale === "no") return no_misc_androidbeta_steps_signin2(inputs)
	if (locale === "pl") return pl_misc_androidbeta_steps_signin2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_androidbeta_steps_signin2(inputs)
	if (locale === "pt") return pt_misc_androidbeta_steps_signin2(inputs)
	if (locale === "ro") return ro_misc_androidbeta_steps_signin2(inputs)
	if (locale === "fi") return fi_misc_androidbeta_steps_signin2(inputs)
	if (locale === "sv") return sv_misc_androidbeta_steps_signin2(inputs)
	if (locale === "vi") return vi_misc_androidbeta_steps_signin2(inputs)
	if (locale === "tr") return tr_misc_androidbeta_steps_signin2(inputs)
	if (locale === "cs") return cs_misc_androidbeta_steps_signin2(inputs)
	if (locale === "bg") return bg_misc_androidbeta_steps_signin2(inputs)
	if (locale === "ru") return ru_misc_androidbeta_steps_signin2(inputs)
	if (locale === "uk") return uk_misc_androidbeta_steps_signin2(inputs)
	if (locale === "ar") return ar_misc_androidbeta_steps_signin2(inputs)
	if (locale === "hi") return hi_misc_androidbeta_steps_signin2(inputs)
	if (locale === "th") return th_misc_androidbeta_steps_signin2(inputs)
	if (locale === "ja") return ja_misc_androidbeta_steps_signin2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_androidbeta_steps_signin2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_androidbeta_steps_signin2(inputs)
	return ko_misc_androidbeta_steps_signin2(inputs)
});
export { misc_androidbeta_steps_signin2 as "misc.androidBeta.steps.signIn" }